export default [
    { name: 'Austrian Peas', protein: 23.2, fat: 1.5, fiber: 5 },
    { name: 'Barley', protein: 12, fat: 2, fiber: 8.7 },
    { name: 'Black Oil Sunflower Seeds', protein: 15, fat: 25, fiber: 40 },
    { name: 'Brown Rice', protein: 7.54, fat: 3.2, fiber: 3.6 },
    { name: 'Buckwheat', protein: 13.2, fat: 3.4, fiber: 10 },
    { name: 'Canadian Peas', protein: 21, fat: 0.9, fiber: 6 },
    { name: 'Canary seed', protein: 13.5, fat: 4.8, fiber: 8 },
    { name: 'Canola', protein: 18.6, fat: 44.1, fiber: 8.5 },
    { name: 'Corn', protein: 9.42, fat: 4.74, fiber: 7.3 },
    { name: 'Flaxseed', protein: 18.3, fat: 42.2, fiber: 27.3 },
    { name: 'Golden Millet', protein: 12, fat: 4, fiber: 8.6 },
    { name: 'Green Peas', protein: 5.42, fat: 0.4, fiber: 5.7 },
    { name: 'Lentils', protein: 24.6, fat: 1.06, fiber: 10.7 },
    { name: 'Maple Peas', protein: 22.9, fat: 1.1, fiber: 6.2 },
    { name: 'Milo', protein: 8, fat: 2.5, fiber: 2.5 },
    { name: 'Mung Beans', protein: 24, fat: 1.2, fiber: 16 },
    { name: 'Oats', protein: 13.5, fat: 5.89, fiber: 10.4 },
    { name: 'Peanuts', protein: 23.2, fat: 43.3, fiber: 8 },
    { name: 'Pigeon Peas', protein: 21.7, fat: 1.49, fiber: 15 },
    { name: 'Popcorn', protein: 9.5, fat: 2.75, fiber: 2.6 },
    { name: 'Red Milo', protein: 9.3, fat: 2.7, fiber: 1.6 },
    { name: 'Safflower', protein: 16, fat: 39, fiber: 26.6 },
    { name: 'Split Green Peas', protein: 23.1, fat: 3.89, fiber: 22.2 },
    { name: 'Thistle/Niger', protein: 12.3, fat: 7, fiber: 2 },
    { name: 'Toasted soy beans', protein: 43.3, fat: 21.6, fiber: 8.1 },
    { name: 'Vetch', protein: 28.8, fat: 0.8, fiber: 5.7 },
    { name: 'Wheat', protein: 13.3, fat: 3.33, fiber: 10 },
    { name: 'White Proso Millet', protein: 11.9, fat: 3.4, fiber: 8.1 },
    { name: 'White Rice', protein: 7.04, fat: 1.03, fiber: 0.1 },
    { name: 'Quinoa', protein: 15, fat: 6.5, fiber: 11 }
  ];